import type { ReactNode } from 'react';

import { ErrorState, LoadingState } from '../../shared/ui/states';
import { CodeItemScreen } from './code-item';
import { PromptItemScreen } from './prompt-item';
import { useLibraryItem } from './use-library-item';

export const LibraryItemPage = ({
  itemId,
  breadcrumb,
  onDeleted,
}: {
  itemId: string;
  breadcrumb: ReactNode;
  onDeleted: () => void;
}) => {
  const { item, versions, pins } = useLibraryItem(itemId);

  if (item.isError || versions.isError) {
    return (
      <div className="p-page">
        <ErrorState
          error={item.error ?? versions.error}
          onRetry={() => {
            void item.refetch();
            void versions.refetch();
          }}
        />
      </div>
    );
  }

  if (!item.data || !versions.data) {
    return (
      <div className="p-page">
        <LoadingState rows={10} />
      </div>
    );
  }

  // Keyed by id alone: a rollback lands while its dialog is open, and remounting would close it.
  const Screen = item.data.kind === 'prompt' ? PromptItemScreen : CodeItemScreen;
  return (
    <Screen
      key={item.data.id}
      item={item.data}
      versions={versions.data}
      pins={pins}
      breadcrumb={breadcrumb}
      onDeleted={onDeleted}
    />
  );
};
